"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TelegramStorage = void 0;
/* eslint-disable prefer-promise-reject-errors */
const sdk_1 = __importDefault(require("@twa-dev/sdk"));
class TelegramStorage {
    constructor() {
        this._data = sdk_1.default.CloudStorage;
    }
    save(key, data) {
        try {
            this._data.setItem(`dewallet-${key}`, data);
            return true;
        }
        catch (error) {
            console.error(error);
            return false;
        }
    }
    // wronh method
    // public get (key: string): Promise<any | undefined> {
    //     return new Promise((resolve, reject) => {
    //         try {
    //             this._data.getItem(`dewallet-${key}`, (error: any, result: any) => {
    //                 if (error || !result) {
    //                     reject(false)
    //                 } else {
    //                     resolve(result)
    //                 }
    //             })
    //         } catch (error) {
    //             console.error(error)
    //             reject(false)
    //         }
    //     })
    // }
    get(key) {
        return new Promise((resolve, reject) => {
            try {
                this._data.getItem(`dewallet-${key}`, (error, result) => {
                    if (error || result === null || result === undefined) {
                        reject(error || 'Result is null or undefined');
                    }
                    else {
                        resolve(result);
                    }
                });
            }
            catch (error) {
                console.error(error);
                reject(error);
            }
        });
    }
    // public del (key: string): boolean {
    //     try {
    //         this._data.removeItem(`dewallet-${key}`)
    //         this._data.removeItem(`wallet-${key}`)
    //         return true
    //     } catch (error) {
    //         console.error(error)
    //         return false
    //     }
    // }
    del(key) {
        return new Promise((resolve, reject) => {
            try {
                this._data.removeItem(`dewallet-${key}`, (error, result) => {
                    if (error || result === null || result === undefined) {
                        reject(error || 'Result is null or undefined');
                    }
                    else {
                        resolve(result);
                    }
                });
            }
            catch (error) {
                console.error(error);
                reject(error);
            }
        });
    }
}
exports.TelegramStorage = TelegramStorage;
